import { Box } from '@repo/ui/Box';
import { Flex } from '@repo/ui/Flex';
import { Separator } from '@repo/ui/Separator';
import { Instructions } from './InstructionItem';
import s from './RequestDetails.module.css';
import { ConfirmationEmail } from './ConfirmationEmail';
import { getSubmittedItems } from './helpers';
import type { RequestDetailsProps } from './types';
import { Text } from '../Language/Language';
import { PackagingOptionProvider } from './PackagingOptionContext';

export const RequestDetails = (props: RequestDetailsProps) => {
  const {
    headerTitle,
    headerSubtitle,
    data,
    replacementTokens,
    children,
    pollingStatus,
    confirmationEmail = true,
  } = props;

  const {
    requestId,
    label,
    qrCode,
    deliveryMethod,
    deliveryType,
    status,
    location,
    orderItems,
    requestItems,
    email,
  } = data;

  return (
    <PackagingOptionProvider
      initialPackagingOption={deliveryMethod?.packagingOption}
    >
      <Box isContainer>
        <Flex direction="column" gap="g-32" className={s.container}>
          <Flex
            direction="column"
            gap={['g-32', 'md:g-48']}
            padding={['px-24', 'md:px-0']}
          >
            <Flex className={s.wrapper} direction="column" gap="g-20">
              <h2 className={s.subtitle}>
                <Text {...headerSubtitle} />
              </h2>
              <h1 className={s.title}>
                <Text {...headerTitle} />
              </h1>
            </Flex>
            {confirmationEmail && (
              <ConfirmationEmail email={email} requestId={requestId} />
            )}
          </Flex>
          <Separator size="sm" />
          <Flex
            direction="column"
            gap={['g-32', 'md:g-48']}
            padding={['px-24', 'md:px-0']}
          >
            <h3 className={s.instructionsHeader}>
              <Text
                langKey={[
                  `Global.confirmation.${status}.instructions.header`,
                  `Global.confirmation.instructions.header`,
                ]}
              />
            </h3>
            <Flex direction="column" gap={'g-32'}>
              <Flex
                direction="column"
                gap="g-40"
                className={s.instructionWrapper}
              >
                <Instructions
                  status={status}
                  deliveryMethod={deliveryMethod}
                  deliveryType={deliveryType}
                  label={label}
                  qrCode={qrCode}
                  pollingStatus={pollingStatus}
                  orderItems={getSubmittedItems({ orderItems, requestItems })}
                  replacementTokens={replacementTokens}
                  location={location}
                />
              </Flex>
              <Separator size="sm" />
              {children}
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </PackagingOptionProvider>
  );
};
